import React, { Component } from 'react';
import axios from 'axios';
import { Container, Button } from 'react-bootstrap';
import { FaTrash } from "react-icons/fa6";
import MenuLeftCMS from './ct-fragmentsidemenu';
import { GetText } from '../config/helper';
import '../config/global';
import CTNA from './ct-fragmentna';
import { FormErrors } from '../inc/error-form';
import Error404 from '../Error404';

const authKey = global.config.kindcode.training[21]+global.config.authBearerKey;

class CTBannerForm extends Component {
    constructor (props) {
        super(props);
        this.state = {
            activelink:"none",
            tab_language: '',
            banner_id: '',
            banner_type: '',
            banner_number: '',
            banner_filename: '',
            banner_filetype: '',
            banner_fileurl: '',
            banner_linkurl: '',
            banner_targeturl: '',
            banner_language: '',
            banner_status: '',
            selectedFileDocument: null,
            formErrors: { banner_type: '', banner_number: '', banner_fileurl: '', banner_linkurl: '', banner_targeturl: '', banner_language: '', banner_status: '', selectedFileDocument:''},
            bannertypeValid: false,
            bannernumberrValid: false,
            bannerfileurlValid: false,
            bannerlinkurlValid: false,
            bannertargeturlValid: false,
            bannerlanguageValid: false,
            bannerstatusValid: false,
            selectedFileDocumentValid: false,
            formValid: false,
            input_disabled: true
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.submitData = this.submitData.bind(this);
        this.loadData = this.loadData.bind(this);
    }
    handleBack = (currpage) => {
        window.location.href=global.config.urlCms+"/"+currpage;
    }
    
    handleInputForm = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value},
            () => { this.validateField(name, value)});
    }
    handleSelectForm = (e) => {
        const inputname = e.target.name; 
        const value = e.target.value;
        this.setState(prevState => {
            return {  
                ...prevState[inputname], [inputname]: value
            }
        }, () => { 
            this.validateField(inputname, value)
        });
        
    }
    onDeleteFileHandler = (e) => {
        var name = '';
        if(e.target.id === "deletePicture") {
            name = 'banner_fileurl';
        }    
        this.setState({
            [name]: ''
        });
      }
    onChangeFileHandler = (e) => {
        if(e.target.files[0] !== undefined) {
            var inputType = e.target.files[0].type;
            var inputValue = e.target.files[0];
            let fieldValidationErrors = this.state.formErrors;
            let selectedFileValid = false;
            if(inputType.indexOf('image') > -1) { //add image
                selectedFileValid = true;
            } else {
                selectedFileValid = false;
            }
            var name =  'selectedFileDocument';
            var validname = 'selectedFileDocumentValid';
            fieldValidationErrors.selectedFileDocument = selectedFileValid ? '' : 'please upload image only';
            
            
            this.setState({
                [name]: inputValue,
                formErrors: fieldValidationErrors,
                [validname] : selectedFileValid
            }, this.validateForm);
        }
      }
    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let bannertypeValid = this.state.bannertypeValid;
        let bannernumberrValid = this.state.bannernumberrValid;
        let bannerfileurlValid = this.state.bannerfileurlValid;
        let bannerlinkurlValid = this.state.bannerlinkurlValid;
        let bannertargeturlValid = this.state.bannertargeturlValid;
        let bannerlanguageValid = this.state.bannerlanguageValid;
        let bannerstatusValid = this.state.bannerstatusValid;
        let selectedFileDocumentValid = this.state.selectedFileDocumentValid;
        switch(fieldName) {
            case 'banner_type': 
                bannertypeValid = value.trim().length > 0;
                fieldValidationErrors.banner_type = bannertypeValid ? '' : 'type need to be filled';
                break;
            case 'banner_number': 
                bannernumberrValid = value.trim().length > 0;
                fieldValidationErrors.banner_number = bannernumberrValid ? '' : 'order of to need to be filled';
                break;
            case 'banner_fileurl': 
                bannerfileurlValid = value.trim().length > 0;
                fieldValidationErrors.banner_fileurl = bannerfileurlValid ? '' : 'file need to be filled';
                break;
            // case 'banner_linkurl': 
            //     bannerlinkurlValid = value.trim().length > 0;
            //     fieldValidationErrors.banner_linkurl = bannerlinkurlValid ? '' : 'destination link banner need to be filled';
            //     break;
            case 'banner_targeturl': 
                if(this.state.banner_linkurl !== "") { 
                    bannertargeturlValid = value.trim().length > 0;
                    fieldValidationErrors.banner_targeturl = bannertargeturlValid ? '' : 'target link banner need to be filled';
                } else { fieldValidationErrors.banner_targeturl = ''; }
                break;
            case 'banner_language': 
                bannerlanguageValid = value.trim().length > 0;
                fieldValidationErrors.banner_language = bannerlanguageValid ? '' : 'language need to be filled';
                break;
            case 'banner_status': 
                bannerstatusValid = value.trim().length > 0;
                fieldValidationErrors.banner_status = bannerstatusValid ? '' : 'status need to be filled';
                break;
            default:
                break;
        }
        
        this.setState({formErrors: fieldValidationErrors,
                        bannertypeValid: bannertypeValid,
                        bannernumberrValid: bannernumberrValid,
                        bannerfileurlValid: bannerfileurlValid,
                        bannerlinkurlValid: bannerlinkurlValid,
                        bannertargeturlValid: bannertargeturlValid,
                        bannerlanguageValid: bannerlanguageValid,
                        bannerstatusValid: bannerstatusValid,
                        selectedFileDocumentValid: selectedFileDocumentValid,
                    }, this.validateForm);
    }
    validateForm() {
        this.setState({formValid: this.state.bannertypeValid && this.state.bannernumberrValid && this.state.bannerfileurlValid && this.state.bannerlinkurlValid  && this.state.bannertargeturlValid && this.state.bannerlanguageValid && this.state.bannerstatusValid && this.state.selectedFileDocumentValid });
    }

    errorClass(error) {
        return(error.length === 0 ? '' : 'has-error');
    }
    submitData(datasend,imgurl,imgname,imgtype) {
        
        
            document.getElementById('loading-area').style.display = 'block'; 
            var bannerType, bannerNumber, bannerFilename, bannerFiletype, bannerFileurl, bannerLinkurl, bannerTargeturl, bannerLanguage, bannerStatus;
            if(this.textInputBannerType.value === '') { bannerType = this.state.banner_type; } else { bannerType = this.textInputBannerType.value; }
            if(this.textInputBannerNumber.value === '') { bannerNumber = this.state.banner_number; } else { bannerNumber = this.textInputBannerNumber.value; }
            if(this.textInputBannerLinkUrl.value === '') { bannerLinkurl = this.state.banner_linkurl; } else { bannerLinkurl = this.textInputBannerLinkUrl.value; }
            if(this.textInputBannerTargetUrl.value === '') { bannerTargeturl = this.state.banner_targeturl; } else { bannerTargeturl = this.textInputBannerTargetUrl.value; }
            if(this.textInputBannerLanguage.value === '') { bannerLanguage = this.state.banner_language; } else { bannerLanguage = this.textInputBannerLanguage.value; }
            if(this.textInputBannerStatus.value === '') { bannerStatus = this.state.banner_status; } else { bannerStatus = this.textInputBannerStatus.value; }
            if(imgurl !== '' && imgurl !== undefined) { bannerFileurl = imgurl; } else { bannerFileurl = this.state.banner_fileurl; }
            if(imgname !== '' && imgname !== undefined) { bannerFilename = imgname; } else { bannerFilename = this.state.banner_filename; }
            if(imgtype !== '' && imgtype !== undefined) { bannerFiletype = imgtype; } else { bannerFiletype = this.state.banner_filetype; }
            var datatext = '{';
            datatext += '"banner_docid":"'+this.state.banner_id+'","banner_type":"'+bannerType+'","banner_number":"'+bannerNumber+'","banner_linkurl":"'+bannerLinkurl+'","banner_targeturl":"'+bannerTargeturl+'","banner_language":"'+bannerLanguage+'","banner_status":"'+bannerStatus+'"';
            var urlFetch = global.config.urlLink;
            if(this.state.banner_id !== '') { 
                datatext += ',"form_id":"form-edit"';
                urlFetch = urlFetch+"/banneredit"; 
            } else { 
                datatext += ',"banner_filename":"'+bannerFilename+'","banner_filetype":"'+bannerFiletype+'","banner_fileurl":"'+bannerFileurl+'"';
                datatext += ',"form_id":"form-add"';
                urlFetch = urlFetch+"/banneradd"; 
            }
            datatext += '}';
            var data = JSON.parse(datatext); 
            
            fetch(urlFetch, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': authKey,
                }, body : JSON.stringify(data)
            }).then(res => {
                if(res.status === 200) 
                    return res.json() 
            }).then( resJson => {
                document.getElementById('loading-area').style.display = 'none'; 
                if(resJson.status === '200') {
                    var param = bannerLanguage.toLowerCase(); if(bannerLanguage === "Indonesian") { param = "indonesia"; } 
                     window.location.href=global.config.urlCms+'/'+this.state.activelink+'/'+param;
                } else {
                    console.log('Something happened wrong');
                }
            }).catch(err => err);
    }
    handleSubmit(e) {
        e.preventDefault();
        if(this.state.banner_type !== '' &&  this.state.banner_number !== '' && this.state.banner_language !== '' && this.state.banner_status !== '' 
          ) {
            
            var arrErrField = [], arrErrValue = [];
            if(this.state.banner_linkurl !== '') {
                if(this.state.banner_targeturl === '') { arrErrField.push('banner_targeturl'); arrErrValue.push(this.textInputBannerTargetUrl.value); } 
            }
            if(arrErrField.length > 0) {
                for(var ck2 in arrErrField) {
                    this.validateField(arrErrField[ck2], arrErrValue[ck2]);
                }    
            } else {
                
                document.getElementById('loading-area').style.display = 'block'; 
                var selectedFileValue = this.state.selectedFileDocument;
                if(selectedFileValue !== null && selectedFileValue.type.indexOf('image') > -1) { 
                    const data = new FormData() 
                    data.append('file', selectedFileValue);
                    data.append('docid', this.state.banner_id);
                    data.append('source', 'banner');
                    
                    axios.post(global.config.urlLink+"/uploadfile", 
                    data, { 
                        headers: { 
                            'content-type': 'multipart/form-data',
                            'Authorization': authKey
                        }
                    }).then(res => { 
                        document.getElementById('loading-area').style.display = 'none'; 
                        if(res.data.status === "200") {
                            this.submitData(this,res.data.values.linkfile1,selectedFileValue.name,selectedFileValue.type);
                        } else {
                            document.getElementById('loading-area').style.display = 'none'; 
                        }
                    }).catch(err => { 
                        document.getElementById('loading-area').style.display = 'none'; 
                    })
                    
                } else {
                    document.getElementById('loading-area').style.display = 'none'; 
                    this.submitData(this,"","","");
                }
            }
        
        } else {
            var arrfieldName = ['banner_type', 'banner_number', 'banner_fileurl', 'banner_language', 'banner_status'];
            var arrvalue = [this.textInputBannerType.value, this.textInputBannerNumber.value, this.state.banner_fileurl, this.textInputBannerLanguage.value, this.textInputBannerStatus.value];
            for(var ck in arrfieldName) {
                this.validateField(arrfieldName[ck], arrvalue[ck]);
            }
        }
        
      }
    loadData(currpage,typelink,docid) {
        if(typelink === 'edit' && docid !== "") {
            document.getElementById('loading-area').style.display = 'block'; 
            fetch(global.config.urlLink+"/bannerview/"+docid, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': authKey,
                }
              }).then(res => {
                if(res.status === 200) 
                    return res.json() 
              }).then( resJson => {
                document.getElementById('loading-area').style.display = 'none'; 
                if(resJson.status === '200') { 
                    var resultContent = resJson.values[0].content[0].maincontent;
                    this.setState({
                        activelink: currpage,
                        stTitle: 'Edit Banner ',
                        banner_id: resJson.values[0].docid,
                        banner_type: resultContent.bannerType,
                        banner_number: resultContent.bannerNumber,
                        banner_filename: resultContent.bannerFilename,
                        banner_filetype: resultContent.bannerFiletype,
                        banner_fileurl: resultContent.bannerFileurl,
                        banner_linkurl: resultContent.bannerLinkurl,
                        banner_targeturl: resultContent.bannerTargeturl,
                        banner_language: resultContent.bannerLanguage,
                        banner_status: resultContent.bannerStatus,
                        tab_language: resultContent.bannerLanguage,
                        formErrors: { banner_type: '', banner_number: '', banner_fileurl: '', banner_linkurl: '', banner_targeturl: '', banner_language: '', banner_status: ''},
                        bannertypeValid: false,
                        bannernumberrValid: false,
                        bannerfileurlValid: false,
                        bannerlinkurlValid: false,
                        bannertargeturlValid: false,
                        bannerlanguageValid: false,
                        bannerstatusValid: false,
                        formValid: false,
                        input_disabled: false
                    }); 
                } else {
                    console.log('Something happened wrong');
                }
              }).catch(err => { 
                document.getElementById('loading-area').style.display = 'none'; 
              });
        } else {
            document.getElementById('loading-area').style.display = 'none'; 
            var bannerLanguage = "";
            if(docid === "eng") { bannerLanguage = "English";  }
            else if(docid === "idn") { bannerLanguage = "Indonesian"; }
          
            this.setState( prevState => {
                return {
                  ...prevState.activelink, activelink: currpage,
                  ...prevState.stTitle, stTitle: GetText() ? "Tambah Banner" : "Add Banner",
                  ...prevState.banner_language, banner_language: bannerLanguage,
                  ...prevState.tab_language, tab_language: bannerLanguage,
                  
                }
            })
        }
    }

    componentDidMount() {
        var urlpath = window.location.pathname;
        if(urlpath.substring(urlpath.length-1,urlpath.length) === "/") {
          urlpath = urlpath.substring(0,urlpath.length-1);
        }
        var arrUrl = urlpath.split("/");
        
        var tabKey="", tabKey2="", docId="";
        if(arrUrl.length===4 && arrUrl[arrUrl.length-1] !== "") {
          tabKey = arrUrl[arrUrl.length-2];
          tabKey2 = arrUrl[arrUrl.length-1];
        } else if(arrUrl.length===5 && arrUrl[arrUrl.length-1] !== "") {
            tabKey = arrUrl[arrUrl.length-3];
            tabKey2 = arrUrl[arrUrl.length-2];
            docId = arrUrl[arrUrl.length-1];
        }
        if(tabKey === "") {
           
          this.setState({
              activelink: "pnf",
              stTitle : (tabKey2 === "add")? "Add " : (tabKey2 === "edit") ? "Edit " : "",
            });
        } else {
          this.loadData(tabKey,tabKey2,docId);
        }
        
      }
    render() {
        var optLanguage = [];
        if(this.state.tab_language === "English") {
            optLanguage.push(<option value="English" selected>English</option>)
        } else if(this.state.tab_language === "Indonesian") {
            optLanguage.push(<option value="Indonesian" selected>Indonesian</option>)
        } else {
            optLanguage.push(<option value="">-- please select --</option>)
            optLanguage.push(<option value="English">English</option>)
            optLanguage.push(<option value="Indonesian">Indonesian</option>)
        }

        var seltypeList = [];
        var seltypeData = global.config.bannerType;
        if(seltypeData.length > 0) {
            for(var u in seltypeData) {
                seltypeList.push(<option value={seltypeData[u].value} key={u}>{seltypeData[u].label}</option>)
            }
        }

        var selstatusList = [];
        var selstatusData = [global.config.bannerStatus[0],global.config.bannerStatus[1]];
        if(selstatusData.length > 0) {
            for(var u in selstatusData) {
                selstatusList.push(<option value={selstatusData[u]} key={u}>{selstatusData[u]}</option>)
            }
        }
        return (
            <div id="setting">
                <Container>
                    { (this.state.activelink === "pnf")? 
                    <Error404 />
                    : 
                    (localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2])? 
                    (<>
                        <div className="row py-5 mb-5">
                        {/* === start - body */}
                            <div className="col-md-3 bg-light">
                            { 
                                (this.state.activelink !== "none") && 
                                <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                            
                            }
                            </div>
                            <div className="col-md-9 p-4">
                            <div className="row">
                                <div>
                                    <h3 className="mb-4">{GetText() ? "Pengaturan Banner" : "Banner Management"}</h3>
                                </div>
                                <div className="mt-3">
                                <div className="row show">
                                    <div className="col-6"><h5>{this.state.stTitle} </h5></div>
                                    <div className="col-6 d-flex justify-content-end">
                                        <Button variant="secondary" size="sm" onClick={this.handleBack.bind(this, this.state.activelink,this.state.banner_id)}>&#9664; back</Button>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                        <form onSubmit={this.handleSubmit}>
                                            <div >
                                            <input type="hidden" required name="banner_id" value={this.state.banner_id} ref={(input) => this.textInputBannerId = input} />
                                            </div>
                                            {(this.state.banner_fileurl !== "") && 
                                            <div className="row mt-3">
                                                <label className="col-md-3" >Picture</label>
                                                <div className="col-md-9 d-flex" >
                                                    <img width="500" src={this.state.banner_fileurl} alt=""/>
                                                    {this.state.banner_id === "" && <a className="linkText ms-2" onClick={this.onDeleteFileHandler} id="deletePicture"><FaTrash /> Delete Picture &raquo;</a> }
                                                </div>
                                            </div> 
                                            }
                                            {this.state.banner_id === "" && 
                                            <div className="row mt-3">
                                                <label className="col-md-3" htmlFor="banner_fileurl">Upload Picture</label>
                                                <div className="col-md-9">
                                                    <input id="fileDocument" type="file"
                                                        onChange={this.onChangeFileHandler} 
                                                    />
                                                    <div className="mt-2 fieldComments">
                                                    
                                                    &bull; Please upload file in jpg, jpeg, png format.<br/>
                                                    &bull; Dimension image min 1200 px x 400 px 
                                                    
                                                    </div>
                                                    <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.selectedFileDocument}/>  }</div>
                                                    
                                                </div>
                                            </div>
                                            }
                                            <div className="row mt-3">
                                                <label className="col-md-3" htmlFor="banner_type">Type</label>
                                                <div className="col-md-9">
                                                    <select name="banner_type" className="form-control" 
                                                        value={this.state.banner_type} 
                                                        onChange={this.handleSelectForm}
                                                        ref={(input) => this.textInputBannerType = input}
                                                    >
                                                    <option value="" key="">-- please select --</option>
                                                    {seltypeList}
                                                    </select>
                                                    <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.banner_type}/>  }</div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <label className="col-md-3" htmlFor="banner_number">Sort to</label>
                                                <div className="col-md-9">
                                                    <input type="number" className="form-control" name="banner_number"
                                                            placeholder={this.state.banner_number}
                                                            value={this.state.banner_number}
                                                            onChange={this.handleInputForm}  
                                                            ref={(input) => this.textInputBannerNumber = input}
                                                            min="1"/> 
                                                    <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.banner_number}/>  }</div>
                                                </div>
                                            </div>
                                            
                                            <div className="row mt-3">
                                                <label className="col-md-3" htmlFor="banner_linkurl">Destination Link Banner</label>
                                                <div className="col-md-9">
                                                    <input type="text" className="form-control" name="banner_linkurl"
                                                        placeholder="https://"
                                                        value={this.state.banner_linkurl}
                                                        onChange={this.handleInputForm}  
                                                        ref={(input) => this.textInputBannerLinkUrl = input}
                                                        />
                                                    <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.banner_linkurl}/>  }</div>
                                                </div>
                                            </div>
                                           
                                            <div className="row mt-3">
                                                <label className="col-md-3" htmlFor="banner_targeturl">Target Link Banner</label>
                                                <div className="col-md-9">
                                                    <select name="banner_targeturl" className="form-control" 
                                                        value={this.state.banner_targeturl} 
                                                        onChange={this.handleSelectForm}
                                                        ref={(input) => this.textInputBannerTargetUrl = input}
                                                    >
                                                        <option value="" key="">-- please select --</option>
                                                        <option value="_self" key="self">same window</option>
                                                        <option value="_blank" key="blank">open to new tab/window</option>
                                                    </select>
                                                    <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.banner_targeturl}/>  }</div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <label className="col-md-3" htmlFor="banner_language">Language</label>
                                                <div className="col-md-9">
                                                    <select name="banner_language" className="form-control" 
                                                        value={this.state.banner_language} 
                                                        onChange={this.handleSelectForm}
                                                        ref={(input) => this.textInputBannerLanguage = input}
                                                    >
                                                    {optLanguage}
                                                    </select>
                                                    <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.banner_language}/>  }</div>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <label className="col-md-3" htmlFor="banner_status">Status</label>
                                                <div className="col-md-9">
                                                    <select name="banner_status" className="form-control" 
                                                        value={this.state.banner_status} 
                                                        onChange={this.handleSelectForm}
                                                        ref={(input) => this.textInputBannerStatus = input}
                                                    >
                                                        <option value="" key="">-- please select --</option>
                                                        {selstatusList}
                                                    </select>
                                                    <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.banner_status}/>  }</div>
                                                </div>
                                            </div>
                                            <div className="row mt-4 mb-3">
                                                <div className="col-md-3"></div>
                                                <div className="col-md-9"><Button type="submit" variant="secondary">Submit</Button></div>
                                            </div>
                                        </form>
                                </div>
                                </div>
                            </div>
                            </div>
                        {/* === end - body */}
                        </div>
                        
                        </>
                    )
                    : 
                    <div><CTNA/></div>
                    }
                    <div id="loading-area" className="d-none loading"></div> 
                    </Container>
            </div>
          );
        }
     }
      
export default CTBannerForm;
